const initialState = {
    docotordetails: [], 
    assiatantdetails:[],
    linkdetails:[],
    
  
  };
  
  const SuprivisorReportsReducers = (state = initialState, action: any) => {
    switch (action.type) {
        case 'FETCH_DOCT_SUCCESS':
            return {... state, docotordetails:action.payload};
            case 'FETCH_ASS_SUCCESS':
            return {... state, assiatantdetails:action.payload};
            case 'FETCH_LINKASS_SUCCESS':
            return {... state, linkdetails:action.payload};
            
           
            
           
          


      default:
        return state;
    }
  };
  
  export default SuprivisorReportsReducers;
  
  